import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Copyright from "./Copyright";
import SnpButton from "../global/SnpButton";
import LockOutlinedIcon from "../ui/icons/LockOutlined";
import {
    Avatar } from "../ui";
import { useSelector } from "react-redux";
import {
  CALLINGURL,
  GETIPADDRESS,
  isEmpty,
  offline_enable,
  printDebugLog,
  setUrl,
  SUCCESS
} from "../../constants/constant";
import { setApiUrl } from "../../actions";
import axios from "axios";
import useForm from "./useForm";
import YouTubeVideo from "../global/YouTubeVideo";
import Loader from "../global/loader/Loader";
import SingleFab from "../global/fab/SingleFab";
import validate from "./validateInfo";
const LoginPage = ({ submitForm }) => {

  const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
  const [baseUrl, setBaseUrl] = useState("");
  const [showVideo, setShowVideo] = useState(false);
  const [loader, setLoader] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotStep, setForgotStep] = useState("email");
  const [forgotData, setForgotData] = useState({ email: "", otp: "", password: "", confirmPassword: "", validationId: "" });
  const [forgotMessage, setForgotMessage] = useState({ text: "", error: false });
  const [resendSeconds, setResendSeconds] = useState(0);

  useEffect(() => {
    if (resendSeconds <= 0) return undefined;
    const timer = window.setInterval(() => setResendSeconds((seconds) => Math.max(0, seconds - 1)), 1000);
    return () => window.clearInterval(timer);
  }, [resendSeconds]);

  const forgotRequest = async () => {
    const email = forgotData.email.trim().toLowerCase();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setForgotMessage({ text: "Enter a valid email address.", error: true });
      return;
    }
    setLoader(true);
    try {
      const response = await axios.post(`${baseUrl}forgot-password/request`, { jcJson: { email } });
      if (response.data.status !== SUCCESS) throw new Error(response.data.errorMessage || "OTP could not be sent.");
      setForgotData((current) => ({ ...current, email }));
      setForgotStep("otp");
      setResendSeconds(Number(response.data.jcJson?.resendAfter) || 45);
      setForgotMessage({ text: "OTP sent to your email.", error: false });
    } catch (error) {
      const retryAfter = Number(error.response?.data?.jcJson?.retryAfter || 0);
      if (retryAfter > 0) setResendSeconds(retryAfter);
      setForgotMessage({ text: error.response?.data?.errorMessage || error.message || "OTP could not be sent.", error: true });
    } finally { setLoader(false); }
  };

  const forgotValidate = async () => {
    if (!/^\d{5}$/.test(forgotData.otp)) {
      setForgotMessage({ text: "Enter the 5-digit OTP.", error: true });
      return;
    }
    setLoader(true);
    try {
      const response = await axios.post(`${baseUrl}forgot-password/validate`, { jcJson: { email: forgotData.email, otp: forgotData.otp } });
      if (response.data.status !== SUCCESS) throw new Error(response.data.errorMessage || "OTP validation failed.");
      setForgotData((current) => ({ ...current, validationId: response.data.jcJson.validationId }));
      setForgotStep("password");
      setForgotMessage({ text: "OTP verified. Enter your new password.", error: false });
    } catch (error) {
      setForgotMessage({ text: error.response?.data?.errorMessage || error.message || "OTP validation failed.", error: true });
    } finally { setLoader(false); }
  };

  const forgotReset = async () => {
    if (forgotData.password.length < 6) {
      setForgotMessage({ text: "Password must contain at least 6 characters.", error: true });
      return;
    }
    if (forgotData.password !== forgotData.confirmPassword) {
      setForgotMessage({ text: "Passwords do not match.", error: true });
      return;
    }
    setLoader(true);
    try {
      const response = await axios.post(`${baseUrl}forgot-password/reset`, { jcJson: {
        email: forgotData.email, validationId: forgotData.validationId, password: forgotData.password,
      } });
      if (response.data.status !== SUCCESS) throw new Error(response.data.errorMessage || "Password could not be changed.");
      setForgotMessage({ text: "Password changed successfully. You can now sign in.", error: false });
      setForgotStep("complete");
    } catch (error) {
      setForgotMessage({ text: error.response?.data?.errorMessage || error.message || "Password could not be changed.", error: true });
    } finally { setLoader(false); }
  };

  const closeForgot = () => {
    setForgotOpen(false);
    setForgotStep("email");
    setForgotData({ email: "", otp: "", password: "", confirmPassword: "", validationId: "" });
    setForgotMessage({ text: "", error: false });
    setResendSeconds(0);
  };


  const getIpAddress = async () => {
    try {
      const response = await axios.get(GETIPADDRESS, {});
      printDebugLog("getIpAddress:", response.data);
      if (!isEmpty(response.data)) {
        const baseUrl = setUrl(response.data);
        setApiUrl(baseUrl);
        setBaseUrl(baseUrl.BACKEND_BASE_URL);
      } else {
        console.warn("getIpAddress not running");
      }
    } catch (error) {
      console.error("getIpAddress error : ", error);
    }
  };

  useEffect(() => {
    printDebugLog("useEffect Login", storeApiUrl, storeApiUrl.BACKEND_BASE_URL);
    if (offline_enable) {
      getIpAddress();
    } else {
      let baseUrl = setUrl(CALLINGURL);
      setApiUrl(baseUrl);
      setBaseUrl(baseUrl.BACKEND_BASE_URL);
    }
  }, []);

  const { handleInputChange, values, handleSubmit, errors, errResponse } = useForm(
    baseUrl,
    submitForm,
    validate,
    setLoader
  );

  return (
    <PageWrapper>
      <BlurredBackground />
      <LoginContainer>
        <Title>
          <StyledLink href="https://www.billmitra.com/" target="_blank" rel="noopener noreferrer">
            A2z-Billmitra SaaS Platform
          </StyledLink>
        </Title>
        <HeaderContainer>
          <StyledAvatar>
            <LockOutlinedIcon />
          </StyledAvatar>
          <Subtitle>Sign In</Subtitle>
        </HeaderContainer>
        <LoginForm>
          <Input type="email" name="useremail" placeholder="Email" required onChange={handleInputChange} />
          <Input type="password" name="password" placeholder="Password" required onChange={handleInputChange} />
          {errors.password && <p>{errors.password}</p>}
          {errResponse.error && <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', color: "red" }}>{errResponse.errMsg}</p>}
          {!loader && <SnpButton variant="contained" color="primary" onClick={handleSubmit}>Login</SnpButton>}
          <ForgotLink type="button" onClick={() => setForgotOpen(true)}>Forgot password?</ForgotLink>
        </LoginForm>
        {forgotOpen && <DialogOverlay onMouseDown={(event) => event.target === event.currentTarget && closeForgot()}>
          <ForgotDialog role="dialog" aria-modal="true" aria-label="Reset password">
            <DialogHeader><h2>Reset password</h2><button type="button" onClick={closeForgot}>×</button></DialogHeader>
            {forgotMessage.text && <DialogMessage $error={forgotMessage.error}>{forgotMessage.text}</DialogMessage>}
            {forgotStep === "email" && <>
              <Input type="email" value={forgotData.email} placeholder="Registered email" onChange={(event) => setForgotData({ ...forgotData, email: event.target.value })} />
              <SnpButton variant="contained" color="primary" disabled={loader} onClick={forgotRequest}>Send OTP</SnpButton>
            </>}
            {forgotStep === "otp" && <>
              <Input type="text" inputMode="numeric" maxLength={5} value={forgotData.otp} placeholder="5-digit OTP" onChange={(event) => setForgotData({ ...forgotData, otp: event.target.value.replace(/\D/g, "") })} />
              <SnpButton variant="contained" color="primary" disabled={loader} onClick={forgotValidate}>Verify OTP</SnpButton>
              <ForgotLink type="button" disabled={loader || resendSeconds > 0} onClick={forgotRequest}>
                {resendSeconds > 0 ? `Resend OTP in ${resendSeconds}s` : "Resend OTP"}
              </ForgotLink>
            </>}
            {forgotStep === "password" && <>
              <Input type="password" value={forgotData.password} placeholder="New password" onChange={(event) => setForgotData({ ...forgotData, password: event.target.value })} />
              <Input type="password" value={forgotData.confirmPassword} placeholder="Confirm new password" onChange={(event) => setForgotData({ ...forgotData, confirmPassword: event.target.value })} />
              <SnpButton variant="contained" color="primary" disabled={loader} onClick={forgotReset}>Change Password</SnpButton>
            </>}
            {forgotStep === "complete" && <SnpButton variant="contained" color="primary" onClick={closeForgot}>Back to Login</SnpButton>}
          </ForgotDialog>
        </DialogOverlay>}
        {showVideo && <YouTubeVideo videoId={'wQ1gN30QJVM'} onDismiss={() => setShowVideo(false)} />}
        {loader && <Loader />}
        <SingleFab onClick={(e) => setShowVideo(true)} />
        <Copyright style={{ marginTop: "1rem" }} />
      </LoginContainer>

    </PageWrapper>
  );
};

export default LoginPage;

const PageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: relative;
  overflow: hidden;
`;

// const BlurredBackground = styled.div`
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   background: url("https://source.unsplash.com/1600x900/?nature,water") no-repeat center center/cover;
//   filter: blur(15px);
//   z-index: 1;
// `;

const BlurredBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background:rgba(1, 51, 62, 0.56)
`;

const LoginContainer = styled.div`
  position: relative;
  z-index: 2;
  background: rgba(255, 255, 255, 0.8);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 400px;
  text-align: center;
`;

const Title = styled.p`
  font-size: 20px;
  margin-bottom: 1rem;
  white-space:pre-wrap;
  overflow-wrap: break-word;
  font-weight: bold;
  color: #01333e;
`;

const StyledLink = styled.a`
  color: inherit; /* Inherits the color from parent (grey) */
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Subtitle = styled.p`
  font-size: 14px;
  margin-bottom: 1px;
  color: #666;
`;

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  margin: 0.5rem 0;
  padding: 0.75rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;

  &:focus {
    border-color: #01333e;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2px; /* Add spacing below the section */
`;

const StyledAvatar = styled(Avatar)`
  background-color: #1bbd7e;
  margin-bottom: 1px;
`;

const ForgotLink = styled.button`
  border: 0;
  background: transparent;
  color: #01333e;
  cursor: pointer;
  margin-top: 0.75rem;
  text-decoration: underline;
  &:disabled { color: #888; cursor: not-allowed; }
`;

const DialogOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.55);
`;

const ForgotDialog = styled.div`
  display: flex;
  flex-direction: column;
  width: min(420px, 100%);
  gap: 0.65rem;
  padding: 1.25rem;
  border-radius: 10px;
  background: white;
  text-align: left;
`;

const DialogHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  h2 { margin: 0; color: #01333e; }
  button { border: 0; background: transparent; cursor: pointer; font-size: 1.6rem; }
`;

const DialogMessage = styled.p`
  margin: 0;
  max-width: 100%;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  color: ${props => props.$error ? "#b42318" : "#087443"};
`;

// const Footer = styled.p`
//   font-size: 0.875rem;
//   color: #666;

//   span {
//     color: #007bff;
//     cursor: pointer;

//     &:hover {
//       text-decoration: underline;
//     }
//   }
// `;


// const LoginButton = styled.button`
//   margin: 1rem 0;
//   padding: 0.75rem;
//   font-size: 1rem;
//   background: #007bff;
//   color: white;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   transition: background 0.3s ease;

//   &:hover {
//     background: #0056b3;
//   }
// `;
